import {
	broncoURL,
	commitHash,
} from 'Vulture/ENV';

import {
	getSession,
} from 'Vulture/Session.js';


// Poll endpoints return { event_count, events, last_update }.

export const pollAIGenerationEventsByAccount = async (accountUUID) => {
	const url = broncoURL + `/ai_generation/events/poll/account/${accountUUID}`;
	return fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const pollAIGenerationEventsByListingColumn = async (listingColumnUUID) => {
	const url = broncoURL + `/ai_generation/events/poll/listing_column/${listingColumnUUID}`;
	return fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const pollAIGenerationEventsByListingConfig = async (listingConfigUUID) => {
	const url = broncoURL + `/ai_generation/events/poll/listing_config/${listingConfigUUID}`;
	return fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const pollAIGenerationEventsByFolder = async (folderID) => {
	const url = broncoURL + `/ai_generation/events/poll/folder/${folderID}`;
	return fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':        'application/json',
			'X-Auth-Session':      getSession().session,
			'X-Spark-API-version': commitHash,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const pollAIGenerationEventsByGalleryFile = async (galleryFileID) => {
	const url = broncoURL + `/ai_generation/events/poll/gallery_file/${galleryFileID}`;
	return fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':        'application/json',
			'X-Auth-Session':      getSession().session,
			'X-Spark-API-version': commitHash,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const toggleAIGeneration = async (listingColumnUUID, nextState) => {
	const url = broncoURL + `/ai_generation/listing/${listingColumnUUID}/toggle/${nextState}`;
	return fetch(url, {
		method:  'PUT',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const setAITriggerType = async (listingColumnUUID, triggerType) => {
	const url = broncoURL + `/ai_generation/listing/${listingColumnUUID}/trigger_type/${triggerType}`;
	return fetch(url, {
		method:  'PUT',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

export const setAIPromptTemplate = async (listingColumnUUID, promptTemplate) => {
	const url = broncoURL + `/ai_generation/listing/${listingColumnUUID}/prompt`;
	return fetch(url, {
		method:  'PUT',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
		body: JSON.stringify({
			prompt_template: promptTemplate,
		}),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};
